import AdminHeader from "components/Headers/AdminHeader";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Button,
  Input,
  Label,
  Badge,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { SKILL_OPTIONS } from "components/constant";
import { REGEX, MAX_FILE_SIZE } from "constants/CommonConstants";
import Avatar from "components/CommonComponents/Avatar";
import { SELECT_CUSTOM_STYLES } from "constants/CommonConstants";

const instructorProfileData = {
  fullName: {
    value: "Rahul Sharma",
    error: "",
  },
  email: {
    value: "rahul.sharma@training.com",
    error: "",
  },
  phone: {
    value: "9876543210",
    error: "",
  },
  profile: {
    value: "",
    error: "",
  },
  experienceYears: {
    value: 8,
    error: "",
  },
  primarySkills: {
    value: [
      { value: "Cable Jointing", label: "Cable Jointing" },
      { value: "Substation Maintenance", label: "Substation Maintenance" },
    ],
    error: "",
  },
  secondarySkills: {
    value: [{ value: "Transformer Testing", label: "Transformer Testing" }],
    error: "",
  },
  certifications: {
    value: ["Certified Electrical Trainer", "Safety Compliance Level 2"],
    error: "",
  },
  certificationsDocs: {
    value: [],
    error: "",
  },
  accountStatus: {
    value: "Active",
  },
};

function InstructorProfile({
  instructorId,
  Edit = false,
  isAdminView = false,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isEditing, setIsEditing] = useState(isAdminView ? Edit : false);
  // we have controlled if edit?=true from url for ADMIN role if edit = indefined/false then view mode
  const [formData, setFormData] = useState(instructorProfileData);

  useEffect(() => {
    // we can check id coming from InstructorDetails File
    if (instructorId) {
      //Api call to fecth the details
    }
  }, [instructorId]);

  const handleChange = (fieldName, newValue) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: {
        ...prev[fieldName],
        value: newValue,
      },
    }));
  };

  const getValidationError = (name, value) => {
    const trimmedValue = typeof value === "string" ? value.trim() : value;

    switch (name) {
      case "fullName":
        return !trimmedValue
          ? "Please enter Full name"
          : !REGEX.ONLY_ALPHABETS_REGEX.test(trimmedValue)
          ? "Full name must contain only letters and spaces"
          : "";

      case "experienceYears":
        return trimmedValue === "" || trimmedValue === null
          ? "Please enter years of experience"
          : isNaN(trimmedValue)
          ? "Experience must be a number"
          : trimmedValue < 0 || trimmedValue > 40
          ? "Experience must be between 0 and 40 years"
          : "";

      case "primarySkills":
        return !Array.isArray(trimmedValue) || trimmedValue.length === 0
          ? "Please select at least one primary skill"
          : "";

      case "certifications":
        return !Array.isArray(trimmedValue) || trimmedValue.length === 0
          ? "Please enter at least one certification"
          : "";

      default:
        return "";
    }
  };

  const validateForm = () => {
    let profileData = { ...formData };

    //get all the keys in array
    Object.keys(profileData).forEach((key) => {
      profileData[key] = {
        ...profileData[key],
        error: getValidationError(key, profileData[key].value),
      };
    });
    setFormData(profileData); //if error set error state
    return Object.values(profileData).every((item) => item.error === "");
  };

  const handleOnBlur = (name, value) => {
    const trimmedValue = typeof value === "string" ? value.trim() : value;
    const error = getValidationError(name, trimmedValue);
    setFormData((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        value: trimmedValue,
        error,
      },
    }));
  };

  const handleSave = () => {
    // if (!validateForm()) return;

    // after success
    setIsEditing(false);
    if (isAdminView) {
      const params = new URLSearchParams(location.search);
      params.delete("edit");
      navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    }
  };

  const handleOnCancel = () => {
    setFormData(instructorProfileData);
    setIsEditing(false);

    if (isAdminView) {
      const params = new URLSearchParams(location.search);
      params.delete("edit");
      navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    }
  };

  const handleEdit = () => {
    setIsEditing(true);
    if (isAdminView) {
      const searchParams = new URLSearchParams(location.search);
      searchParams.set("edit", "true");

      navigate(`${location.pathname}?${searchParams.toString()}`, {
        replace: true,
      });
    }
    setFormData({
      fullName: { value: instructorProfileData.fullName.value, error: "" },
      email: { value: instructorProfileData.email.value, error: "" },
      phone: { value: instructorProfileData.phone.value, error: "" },
      profile: { value: instructorProfileData.profile.value, error: "" },
      experienceYears: {
        value: instructorProfileData.experienceYears.value,
        error: "",
      },
      primarySkills: {
        value: [...instructorProfileData.primarySkills.value],
        error: "",
      },
      accountStatus: { value: instructorProfileData.accountStatus.value },
    });
  };

  const removeDocument = (index) => {
    setFormData((prev) => ({
      ...prev,
      certificationsDocs: {
        value: prev.certificationsDocs.value.filter((_, i) => i !== index),
        error: "",
      },
    }));
  };

  const handleImageChange = (file) => {
    if (!file) return;
    //validate the image size
    if (file.size > MAX_FILE_SIZE) {
      setFormData((prev) => ({
        ...prev,
        profile: {
          value: null,
          error: "Image should not exceed maz size of 2 Mb", // Image should not exceed 2 mb
        },
      }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      profile: {
        value: file,
        error: "",
      },
    }));
  };
  return (
    <>
      {/* If ADMIN  view by id -instructor details if TRAINER - my profile */}
      {isAdminView ? (
        <AdminHeader name="Instructor Details" />
      ) : (
        <AdminHeader name="My Profile" />
      )}

      <Container className="mt--6" fluid>
        <Row>
          <Col xl="12">
            <Card className="shadow mb-4">
              <CardBody>
                <Row className="align-items-center">
                  <Col md="2" className="text-center">
                    <FormGroup className="text-center position-relative">
                      {formData.profile.value ? (
                        <img
                          src={
                            formData.profile.value instanceof File
                              ? URL.createObjectURL(formData.profile.value)
                              : formData.profile.value
                          }
                          alt="Profile"
                          className="profile-photo-preview"
                        />
                      ) : (
                        <Avatar name={formData.fullName.value} />
                      )}

                      {isEditing && (
                        <>
                          <small className="text-muted d-block mt-2">
                            Accepted formats: PNG, JPG. Maximum file size: 2 MB.
                          </small>
                          <span
                            className="profile-img-edit cursor-pointer"
                            onClick={() =>
                              document.getElementById("profile").click()
                            }
                          >
                            <i className="fa fa-camera" />
                          </span>

                          <Input
                            type="file"
                            id="profile"
                            accept="image/*"
                            className="d-none"
                            onChange={(e) =>
                              handleImageChange(e.target.files[0])
                            }
                          />
                        </>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md="7">
                    <h2 className="mb-1">{formData.fullName.value}</h2>

                    <Badge
                      pill
                      color={
                        formData.accountStatus.value === "Active"
                          ? "success"
                          : "warning"
                      }
                    >
                      {formData.accountStatus.value}
                    </Badge>
                  </Col>

                  <Col md="3" className="text-right">
                    {!isEditing ? (
                      <Button
                        className="btn-deep-blue"
                        color="primary"
                        onClick={handleEdit}
                      >
                        <i className="fa-solid fa-pencil mr-1" />
                        Edit
                      </Button>
                    ) : (
                      <>
                        <Button
                          color="secondary"
                          className="mr-2 px-4 py-2"
                          onClick={handleOnCancel}
                        >
                          Cancel
                        </Button>

                        <Button
                          color="primary"
                          className="btn-deep-blue px-4 py-2"
                          onClick={handleSave}
                        >
                          Save
                        </Button>
                      </>
                    )}
                  </Col>
                </Row>
              </CardBody>
            </Card>

            <Card className="shadow mb-4">
              <CardHeader>
                <h3>Basic Information</h3>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md="4">
                    <FormGroup className="d-flex flex-column align-items-start">
                      <Label>
                        Full Name{" "}
                        {isEditing && <span className="text-danger"> *</span>}
                      </Label>
                      {isEditing ? (
                        <>
                          <Input
                            type="text"
                            name="fullName"
                            value={formData.fullName.value}
                            onChange={(e) =>
                              handleChange("fullName", e.target.value)
                            }
                            onBlur={(e) =>
                              handleOnBlur(e.target.name, e.target.value)
                            }
                            className={
                              formData.fullName.error ? "is-invalid" : ""
                            }
                          />
                          {formData.fullName.error && (
                            <div className="invalid-feedback d-block">
                              {formData.fullName.error}
                            </div>
                          )}
                        </>
                      ) : (
                        <small className="small-text">
                          {formData.fullName.value}
                        </small>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md="4">
                    <FormGroup className="d-flex flex-column align-items-start">
                      <Label>Email</Label>
                      {isEditing ? (
                        <Input
                          type="email"
                          name="email"
                          value={formData.email.value}
                          onChange={(e) =>
                            handleChange("email", e.target.value)
                          }
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          className={formData.email.error ? "is-invalid" : ""}
                        />
                      ) : (
                        <small className="small-text">
                          {formData.email.value}
                        </small>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md="4">
                    <FormGroup className="d-flex flex-column align-items-start">
                      <Label>Mobile Number</Label>

                      {isEditing ? (
                        <InputGroup className="input-group-merge">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText className="d-flex align-items-center">
                              <span className="mr-2">🇮🇳</span> +91
                            </InputGroupText>
                          </InputGroupAddon>

                          <Input
                            type="text"
                            name="phone"
                            value={formData.phone.value}
                            onChange={(e) =>
                              handleChange("phone", e.target.value)
                            }
                            onBlur={(e) =>
                              handleOnBlur(e.target.name, e.target.value)
                            }
                            className={formData.phone.error ? "is-invalid" : ""}
                            maxLength={10}
                          />
                        </InputGroup>
                      ) : (
                        <small className="small-text">
                          🇮🇳 +91 {formData.phone.value}
                        </small>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            <Card className="shadow mb-4">
              <CardHeader>
                <h3>Professional Details</h3>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md="4">
                    <FormGroup className="d-flex flex-column align-items-start">
                      <Label>
                        Years of Experience{" "}
                        {isEditing && <span className="text-danger"> *</span>}
                      </Label>
                      {isEditing ? (
                        <>
                          <Input
                            type="number"
                            name="experienceYears"
                            value={formData.experienceYears.value}
                            onChange={(e) =>
                              handleChange("experienceYears", e.target.value)
                            }
                            onBlur={(e) =>
                              handleOnBlur(e.target.name, e.target.value)
                            }
                            className={
                              formData.experienceYears.error ? "is-invalid" : ""
                            }
                          />
                          {formData.experienceYears.error && (
                            <div className="invalid-feedback d-block">
                              {formData.experienceYears.error}
                            </div>
                          )}
                        </>
                      ) : (
                        <small className="small-text">
                          {formData.experienceYears.value} Years
                        </small>
                      )}
                    </FormGroup>
                  </Col>
                  {/* Primary Skills */}
                  <Col md="4">
                    <FormGroup className="d-flex flex-column align-items-start">
                      <Label>
                        Primary Skills{" "}
                        {isEditing && <span className="text-danger"> *</span>}
                      </Label>
                      {isEditing ? (
                        <>
                          <Select
                            isMulti
                            classNamePrefix="react-select p-5"
                            name="primarySkills"
                            placeholder="Select primary skills"
                            styles={SELECT_CUSTOM_STYLES}
                            options={SKILL_OPTIONS}
                            value={formData.primarySkills.value}
                            onChange={(selected) =>
                              handleChange("primarySkills", selected || [])
                            }
                            onBlur={() =>
                              handleOnBlur(
                                "primarySkills",
                                formData.primarySkills.value
                              )
                            }
                          />
                          {formData.primarySkills.error && (
                            <div className="invalid-feedback d-block">
                              {formData.primarySkills.error}
                            </div>
                          )}
                        </>
                      ) : (
                        <ul>
                          {formData.primarySkills.value.map((s, i) => (
                            <li key={i}>{s.label}</li>
                          ))}
                        </ul>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            <Card className="shadow">
              <CardHeader>
                <h3>Account Status</h3>
              </CardHeader>
              <CardBody>
                <FormGroup className="d-flex flex-column align-items-start">
                  <Label className="form-control-label">Status</Label>
                  <span>
                    <Badge
                      className="px-3 py-2"
                      color={
                        formData.accountStatus.value.toUpperCase() === "ACTIVE"
                          ? "success"
                          : "warning"
                      }
                      pill
                    >
                      {formData.accountStatus.value.toUpperCase() === "INACTIVE"
                        ? "Suspended"
                        : formData.accountStatus.value}
                    </Badge>
                  </span>
                </FormGroup>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default InstructorProfile;
